import { KEYUTIL, KJUR } from "jsrsasign";
import { AuthenticationTokens } from "../../appstore/models";
import AWS from "aws-sdk";
var key_id: string = "";

var myHeaders = new Headers();
myHeaders.set("Cache-Control", "no-STORAGE");
var urlParams = new URLSearchParams(window.location.search);
const redirectURI = window.location.origin;
const STORAGE = sessionStorage;
const STORAGE_AUTH_TOKENS_KEY = "oidcAuthTokens";
const ONE_HOUR_IN_MS = 1000 * 60 * 60;
interface BaseOidcConfiguration {
  clientId: string;
  keysUrl: string;
  authorizeUrl: string;
  oauthTokenUrl: string;
  userInfoUrl: string;
  redirectPath: string;
  scope: string;
  region: string;
  encodeAuthorizePayloadJson?: boolean;
}

interface CognitoOidcConfiguration extends BaseOidcConfiguration {
  /** Use cognito pool to pull AWS credentials after authenticating */
  cognitoIdentityPoolId: string;
  cognitoPoolKey: string;
}

interface StandardOidcConfiguration extends BaseOidcConfiguration {
  /** Use OIDC token and STS to gain access to this role after authenticating */
  roleArn: string;
}

type OidcConfiguration = CognitoOidcConfiguration | StandardOidcConfiguration;

interface OidcTokens {
  id_token: string;
  access_token: string;
  refresh_token: string;
}

type AuthenticateResponse =
  | {
      success: false;
      message: string;
    }
  | {
      success: true;
      tokens: AuthenticationTokens;
      userInfo: any;
    };

//verify token
async function verifyToken(
  token: string,
  oidcConfiguration: OidcConfiguration
) {
  //get oidc keys
  const keysUrl = oidcConfiguration.keysUrl;
  const response = await fetch(keysUrl);
  const responseObj = await response.json();
  const keys = responseObj["keys"] as any;

  //Get the kid (key id)
  var tokenHeader = parseJWTHeader(token);
  key_id = tokenHeader.kid;

  //search for the kid key id in the oidc Keys
  const key = keys.find((key: any) => key.kid === key_id);
  if (key === undefined) {
    return "Public key not found in oidc jwks.json";
  }

  //verify JWT Signature
  var keyObj = KEYUTIL.getKey(key);
  //@ts-ignore
  var isValid = KJUR.jws.JWS.verifyJWT(token, keyObj, { alg: ["RS256"] });
  if (isValid) {
  } else {
    return "Signature verification failed";
  }

  //verify token has not expired
  var tokenPayload = parseJWTPayload(token);
  if (Date.now() >= tokenPayload.exp * 1000) {
    return "Token expired";
  }

  //verify app_client_id
  var n = tokenPayload.aud.localeCompare(oidcConfiguration.clientId);
  if (n !== 0) {
    return "Token was not issued for this audience";
  }
  return "verified";
}

//Convert Payload from Base64-URL to JSON
const decodePayload = (payload: string) => {
  const cleanedPayload = payload.replace(/-/g, "+").replace(/_/g, "/");
  const decodedPayload = atob(cleanedPayload);
  const uriEncodedPayload = Array.from(decodedPayload).reduce((acc, char) => {
    const uriEncodedChar = ("00" + char.charCodeAt(0).toString(16)).slice(-2);
    return `${acc}%${uriEncodedChar}`;
  }, "");
  const jsonPayload = decodeURIComponent(uriEncodedPayload);

  return JSON.parse(jsonPayload);
};

//Parse JWT Payload
const parseJWTPayload = (token: string) => {
  const parts = token.split(".");
  const payload = parts[1];
  const jsonPayload = decodePayload(payload);

  return jsonPayload;
};

//Parse JWT Header
const parseJWTHeader = (token: string) => {
  //const [header, payload, signature] = token.split(".");
  const parts = token.split(".");
  const jsonHeader = decodePayload(parts[0]);

  return jsonHeader;
};

//Generate a Random String
const getRandomString = () => {
  const randomItems = new Uint32Array(48);
  crypto.getRandomValues(randomItems);

  const binaryStringItems = randomItems.map(
    // @ts-ignore
    (dec) => `0${dec.toString(16).substr(-2)}`
  );
  return binaryStringItems.reduce((acc, item) => `${acc}${item}`, "");
};

//Encrypt a String with SHA256
const encryptStringWithSHA256 = async (s: string) => {
  const PROTOCOL = "SHA-256";
  const textEncoder = new TextEncoder();
  const encodedData = textEncoder.encode(s);
  return crypto.subtle.digest(PROTOCOL, encodedData);
};

//Convert Hash to Base64-URL
const hashToBase64url = (arrayBuffer: ArrayBuffer) => {
  const items = new Uint8Array(arrayBuffer);
  const stringifiedArrayHash = items.reduce(
    (acc, i) => `${acc}${String.fromCharCode(i)}`,
    ""
  );
  const decodedHash = btoa(stringifiedArrayHash);

  const base64URL = decodedHash
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
  return base64URL;
};

const redirectToLogin = async (oidcConfiguration: OidcConfiguration) => {
  // Save current path
  // Always use sessionStorage for pathname to keep state local to the current tab
  sessionStorage.setItem("pathname", window.location.pathname);

  // Create random "state"
  const state = getRandomString();
  STORAGE.setItem("pkce_state", state);

  // Create PKCE code verifier
  const code_verifier = getRandomString();
  STORAGE.setItem("code_verifier", code_verifier);

  // Create code challenge
  var arrayHash = await encryptStringWithSHA256(code_verifier);
  var code_challenge = hashToBase64url(arrayHash);
  STORAGE.setItem("code_challenge", code_challenge);

  // Redirtect user-agent to /authorize endpoint
  const loginUrl = new URL(oidcConfiguration.authorizeUrl);
  loginUrl.searchParams.append("response_type", "code");
  loginUrl.searchParams.append("state", state);
  loginUrl.searchParams.append("client_id", oidcConfiguration.clientId);
  loginUrl.searchParams.append(
    "redirect_uri",
    `${redirectURI}${oidcConfiguration.redirectPath}`
  );
  loginUrl.searchParams.append("scope", oidcConfiguration.scope);
  loginUrl.searchParams.append("code_challenge_method", "S256");
  loginUrl.searchParams.append("code_challenge", code_challenge);

  window.location.href = loginUrl.href;
};

const authenticateUser = async (
  code: string,
  codeVerifier: string,
  oidcConfig: OidcConfiguration
): Promise<AuthenticateResponse> => {
  // Fetch OAuth2 tokens from oidc
  //const code_verifier = STORAGE.getItem("code_verifier");

  const authUrl = new URL(oidcConfig.oauthTokenUrl);
  const options: RequestInit = {
    method: "post",
  };
  if (oidcConfig.encodeAuthorizePayloadJson) {
    options.headers = {
      "Content-Type": "application/json",
    };
    options.body = JSON.stringify({
      client_id: oidcConfig.clientId,
      code_verifier: codeVerifier,
      grant_type: "authorization_code",
      code: code,
      redirect_uri: redirectURI,
    });
  } else {
    options.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
    };
    authUrl.searchParams.append("grant_type", "authorization_code");
    authUrl.searchParams.append("client_id", oidcConfig.clientId);
    authUrl.searchParams.append("code_verifier", codeVerifier);
    authUrl.searchParams.append("redirect_uri", redirectURI);
    authUrl.searchParams.append("code", code);
  }

  const response = await fetch(authUrl.href, options);
  const responseJson = await response.json();
  const oidcTokens = responseJson as OidcTokens;
  if (!oidcTokens || !oidcTokens.id_token) {
    return {
      success: false,
      message: `Error fetching token: ${oidcTokens}`,
    };
  }
  const idVerified = await verifyToken(oidcTokens.id_token, oidcConfig);
  Promise.resolve(idVerified).then(function (value) {
    if (value.localeCompare("verified")) {
      console.log("Invalid ID Token - " + value);
      return;
    }
  });

  // Fetch from /user_info
  const userInfoResponse = await fetch(oidcConfig.userInfoUrl, {
    method: "post",
    headers: {
      authorization: "Bearer " + oidcTokens.access_token,
    },
  });
  const userInfo = await userInfoResponse.json();
  // Return token and user info
  return {
    success: true,
    tokens: {
      accessToken: oidcTokens.access_token,
      refreshToken: oidcTokens.refresh_token,
      idToken: oidcTokens.id_token,
    },
    userInfo: userInfo,
  };
};

type FullAuthenticateResponse = {
  success: boolean;
  message: string;
};
function getOidcAuthTokensFromSession(): OidcTokens | null {
  const oidcAuthTokensJson = STORAGE.getItem(STORAGE_AUTH_TOKENS_KEY);
  if (typeof oidcAuthTokensJson === "string") {
    return JSON.parse(oidcAuthTokensJson) as OidcTokens;
  }
  return null;
}
function clearOidcSession() {
  STORAGE.removeItem(STORAGE_AUTH_TOKENS_KEY);
}
function updateOidcAuthSession(oidcTokens: OidcTokens) {
  STORAGE.setItem(STORAGE_AUTH_TOKENS_KEY, JSON.stringify(oidcTokens));
}

function getOidcCredentials(idToken: string, oidcConfig: OidcConfiguration) {
  if ("roleArn" in oidcConfig) {
    const credentials = new AWS.WebIdentityCredentials(
      {
        RoleArn: oidcConfig.roleArn,
        WebIdentityToken: idToken,
        RoleSessionName: "local-app",
        DurationSeconds: 3600,
      },
      {
        region: oidcConfig.region,
      }
    );
    return credentials;
  } else {
    const config = {
      IdentityPoolId: oidcConfig.cognitoIdentityPoolId,
      Logins: {
        [oidcConfig.cognitoPoolKey]: idToken,
      },
    };
    const credentials = new AWS.CognitoIdentityCredentials(config, {
      region: oidcConfig.region,
    });
    return credentials;
  }
}

async function refreshCredentials(
  credentials: AWS.CognitoIdentityCredentials | AWS.WebIdentityCredentials,
  oidcConfig: OidcConfiguration
) {
  await credentials.refresh((err) => {
    if (err) {
      console.log("ERROR REFRESHING AWS TOKEN", err);
      clearOidcSession();
      redirectToLogin(oidcConfig);
    }
  });
  // schedule the next credential refresh when they're about to expire
  setTimeout(
    () => refreshCredentials(credentials, oidcConfig),
    credentials.expireTime
      ? credentials.expireTime.getTime() - new Date().getTime()
      : ONE_HOUR_IN_MS
  );
}

async function authenticateOidc(): Promise<FullAuthenticateResponse> {
  const oidcConfig = (await (
    await fetch(`${process.env.PUBLIC_URL}/oidc.json`)
  ).json()) as OidcConfiguration;

  let oidcAuthTokens = getOidcAuthTokensFromSession();
  const redirectCode = urlParams.get("code");
  const redirectCodeVerifier = STORAGE.getItem("code_verifier");
  const redirectState = urlParams.get("state");

  // No oidc auth tokens in the session, but we have an auth code in the URL.
  // Authenticate with oidc.
  if (
    !oidcAuthTokens &&
    redirectCode &&
    redirectCodeVerifier &&
    redirectState
  ) {
    const result = await authenticateUser(
      redirectCode,
      redirectCodeVerifier,
      oidcConfig
    );
    if (!result.success) {
      // Error authenticating with the provided tokens.  Redirect to login.
      await redirectToLogin(oidcConfig);
      return {
        success: false,
        message: "Redirecting to login",
      };
    }
    oidcAuthTokens = {
      id_token: result.tokens.idToken,
      access_token: result.tokens.accessToken,
      refresh_token: result.tokens.refreshToken,
    };
    updateOidcAuthSession(oidcAuthTokens);
    const pathname = sessionStorage.getItem("pathname");
    if (pathname && pathname.length > 1) {
      window.location.href = pathname;
    }
  }

  // oidc tokens found in the session
  // Use thes to pull AWS credentials
  if (oidcAuthTokens) {
    const credentials = getOidcCredentials(oidcAuthTokens.id_token, oidcConfig);
    AWS.config.credentials = credentials;

    await refreshCredentials(credentials, oidcConfig);
    return {
      success: true,
      message: "Successfully authenticated with oidc",
    };
  } else {
    // No credentials set. Redirect to login.
    await redirectToLogin(oidcConfig);
    return {
      success: false,
      message: "Redirecting to login",
    };
  }
}
export { authenticateOidc };
